import { render, staticRenderFns } from "./terraform-statefile-azure.vue?vue&type=template&id=7aff5fc2&scoped=true&"
import script from "./terraform-statefile-azure.vue?vue&type=script&lang=js&"
export * from "./terraform-statefile-azure.vue?vue&type=script&lang=js&"
import style0 from "./terraform-statefile-azure.vue?vue&type=style&index=0&id=7aff5fc2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7aff5fc2",
  null
  
)

export default component.exports